import { setActiveAction as setActiveActionDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    action?: string,
}

export const setActiveAction = ({
    action,
    eventEmitter,
}: Props) => {
  
    setActiveActionDiagram(action)
//    eventEmitter.emit(Event.applyClusterMetricFilter);
};

